T.Rules = {};

T.Rules.Api = Class(
	/**
	 * @lends {T.Rules.Api#}
	 */
	{
		TAGS: ['h1', 'h2', 'h3', 'span', 'p', 'img', 'div', 'ul', 'li', 'strong', 'br'],
		RULE_HEADER_TAG: 'h2',
		RULE_HEADER_REGEX: /^(\d+(?:\.?\d+)?(?:\.?\d+)?)/,
		RULE_ITEM_TAG: 'p',
		RULE_ITEM_REGEX: /^(\d+\.?(?:\d+\.?)?(?:\d+\.?)?\s*)/,

		_sectionList: [],

		__construct: function(par){
			this.par = par;
			this.node = mkE({
				tag: 'div',
				className: 'rules-list-api'
			});

			this._mGetRules = new DR.roadgames.GetWebRules();
			this._mGetRules.language = D.LANG;
			this._mGetRules.type = par.type;
			this._mGetRules.select = [
				new DR.roadgames.select.WebRules().data()
			];
			this._mGetRules.onLoad = this._mGetRulesRe;
			this._mGetRules.onError = this._mGetRulesErr;
			par.apiCall.addMethod(this._mGetRules);
		},

		scrollIntoView: function(id){
			D.scrollIntoView(document.getElementById(id), null, document.getElementById('header').clientHeight);
		},

		_mGetRulesErr: function() {
			this.par.onError(this._mGetRules.error);
		},

		_mGetRulesRe: function(){
			const rules = JSON.parse(this._mGetRules.re.data);
			const node = {
				tag: 'div',
				className: 'rules-items' + (this.par.smallRules ? ' rules-small' : ''),
				els: []
			};

			this._prepareBlocks(rules, node);

			this._sectionsListNode = mkE({
				tag: 'div',
				className: 'sections-list',
				els: this._sectionList
			}).append(this.node);

			this._rulesNode = mkE(node).append(this.node);

			D.replaceWithNode(this._rulesNode, /%COOKIE_SETTINGS%/g, function() {
				return mkE({
					tag: 'button',
					className: 'button button-pink',
					text: D.Lang.get('cookies.settings'),
					onclick: D.cookiesSettings
				});
			});
		},

		_extractText: function(block){
			let re = [];
			if( is_array(block.contents) ){
				for( let i = 0; i < block.contents.length; i++ ){
					re.push(this._extractText(block.contents[i]))
				}
			} else if( block.type === 'text' ){
				re.push(block.content);
			} else{
				re.push(block.contents);
			}
			return re.join('\n');
		},

		_extractSectionHeader: function(sectionLinkText) {
			const sectionLinkNumberMatch = sectionLinkText.match(this.RULE_HEADER_REGEX);
			if( !sectionLinkNumberMatch ){
				return null;
			}
			const sectionLinkHref = 'terms-' + sectionLinkNumberMatch[0].split('.').join('-');
			this._sectionList.push({
				tag: 'div',
				className: 'section-item',
				els: [{
					tag: 'a',
					className: 'noAjax',
					href: '#' + sectionLinkHref,
					text: sectionLinkText,
					onclick: D.closure(this, function(sectionLinkHref, e){
						Section.replaceUrl(location.href.replace(location.hash, '#' + sectionLinkHref));
						e.preventDefault();
						this.scrollIntoView(sectionLinkHref);
					}, sectionLinkHref)
				}]
			});
			return sectionLinkHref;
		},

		_prepareBlocks: function(blocks, parent){
			for( let i = 0; i < blocks.length; i++ ){
				const block = blocks[i];
				let child;
				if( in_array(block.tag, this.TAGS) ){
					child = {
						tag: block.tag
					};
					if( block.tag === this.RULE_HEADER_TAG ){
						const sectionHeaderText = this._extractText(block);
						const sectionHeaderNumber = this._extractSectionHeader(sectionHeaderText);
						if( sectionHeaderNumber ){
							child.id = sectionHeaderNumber;
							child.text = sectionHeaderText;
						}
					} else if( block.tag === this.RULE_ITEM_TAG ){
						const rulesText = this._extractText(block);
						const rulesTextNumberMatch = rulesText.match(this.RULE_ITEM_REGEX);
						if( rulesTextNumberMatch ){
							child.els = [
								{
									tag: 'span',
									className: 'prefix',
									text: rulesTextNumberMatch[0]
								}
							];
							if( is_array(block.contents) ){
								block.contents[0].content = block.contents[0].content.replace(rulesTextNumberMatch[0], '');
								this._prepareBlocks(block.contents, child);
							} else{
								child.els.push(block.contents.replace(rulesTextNumberMatch[0], ''));
							}
						}
					}
					if( !child.text && !child.els ){
						if( is_array(block.contents) ){
							child.els = [];
							this._prepareBlocks(block.contents, child);
						} else{
							child.text = block.contents;
						}
					}
				} else if( block.type === 'link' ){
					child = {
						tag: 'a',
						href: block.href.substr(0, 1) === '/' ? D.url(block.href) : block.href
					};
					if( is_array(block.contents) ){
						child.els = [];
						this._prepareBlocks(block.contents, child);
					} else{
						child.text = block.contents;
					}
				} else if( block.type === 'text' ){
					child = block.content;
				} else {
					continue;
				}
				parent.els.push(child);
			}
		}
	},
	mkE.Base
);
